import styled, { css } from "styled-components";
import { token } from "./token.js";
import { getThumbPosition } from "./getThumbPosition.js";
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1b6hxsw-0"
})(["position:relative;display:flex;gap:", ";align-items:center;"], token.spacing3);
const SliderContainer = styled.div.withConfig({
  displayName: "SliderContainer",
  componentId: "sc-1b6hxsw-1"
})(["position:relative;display:flex;flex:1;align-items:center;height:24px;"]);
const IconStyled = styled.div.withConfig({
  displayName: "IconStyled",
  componentId: "sc-1b6hxsw-2"
})(["display:grid;color:", ";"], (props) => props.$isDisabled ? token.colorTextDisabled : token.colorTextMuted);
const track = css(["position:relative;box-sizing:border-box;height:24px;padding:0;border:10px solid transparent;border-radius:2px / 50%;background-image:var(--track-background);background-clip:padding-box;border-inline:none;appearance:none;"]);
const thumb = css(["position:relative;top:50%;bottom:0;width:20px;height:20px;padding:0;opacity:0;pointer-events:", ";transform:translateY(-50%);-webkit-appearance:none;appearance:none;"], (props) => props.$isDisabled ? "none" : "auto");
function getGradient(props) {
  const gradientValue = getThumbPosition(props.min, props.max, props.value);
  let fillStart;
  let fillEnd;
  if (Array.isArray(props.$values)) {
    fillStart = getThumbPosition(props.min, props.max, props.$values[0]);
    fillEnd = getThumbPosition(props.min, props.max, props.$values[1]);
  } else if (props.$isFromCenter) {
    fillStart = `min(${gradientValue}, 50%)`;
    fillEnd = `max(50%, ${gradientValue})`;
  } else {
    fillStart = "0";
    fillEnd = gradientValue;
  }
  const fillColor = props.$isDisabled ? token.gray400 : token.brandPrimary500;
  return `linear-gradient(
		90deg,
		${token.gray100a} ${fillStart},
		${fillColor} ${fillStart},
		${fillColor} ${fillEnd},
		${token.gray100a} ${fillEnd}
	)`;
}
const SliderInput = styled.input.attrs((props) => ({
  style: {
    "--track-background": getGradient(props)
  }
})).withConfig({
  displayName: "SliderInput",
  componentId: "sc-1b6hxsw-3"
})(["position:absolute;left:0;width:100%;margin:0;padding:0;border:none;background:transparent;cursor:", ";pointer-events:", ";-webkit-appearance:none;appearance:none;&:focus{outline:none;}&::-webkit-slider-thumb{", "}&::-moz-range-thumb{", " transform:none;}&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}"], (props) => props.$isDisabled ? "default" : "pointer", (props) => props.$isRange || props.$isDisabled ? "none" : "auto", thumb, thumb, track, track);
const ThumbContainer = styled.div.withConfig({
  displayName: "ThumbContainer",
  componentId: "sc-1b6hxsw-4"
})(["position:absolute;top:50%;z-index:1;box-sizing:border-box;width:16px;height:16px;opacity:var(--thumb-opacity,", ");pointer-events:none;transition:opacity 120ms ease-in-out;", " ", ":hover + &{--thumb-opacity:1;--thumb-inner-circle-visibility:visible;--thumb-border:0 0 0 1px ", ";--thumb-shadow:", ",", ";}", ":focus-visible + &{--thumb-opacity:1;--thumb-inner-circle-visibility:visible;--thumb-border:0 0 0 1px ", ";--thumb-shadow:0 0 0 3px ", ";}", ":active + &{--thumb-opacity:1;--thumb-inner-circle-visibility:visible;--thumb-border:0 0 0 1px ", ";--thumb-shadow:", ",", ";--thumb-size:20px;}"], (props) => props.$isInactive ? 0 : 1, (props) => props.$isInactive && css(["", ":hover &{--thumb-opacity:", ";}"], SliderContainer, props.$isDisabled ? 0 : 1), SliderInput, token.gray100a, token.elevationStatic, token.elevation1, SliderInput, token.gray100a, token.gray100a, SliderInput, token.gray100a, token.elevationStatic, token.elevation2);
const ThumbCircle = styled.div.withConfig({
  displayName: "ThumbCircle",
  componentId: "sc-1b6hxsw-5"
})(["position:absolute;top:50%;left:50%;width:var(--thumb-size,16px);height:var(--thumb-size,16px);border-radius:", ";background:", ";", " transform:translate(-50%,-50%);&::before{content:'';position:absolute;top:50%;left:50%;display:block;width:8px;height:8px;border-radius:", ";background-color:", ";visibility:var(--thumb-inner-circle-visibility,hidden);transform:translate(-50%,-50%);}"], token.radiusCircle, (props) => props.$isDisabled ? token.gray400 : token.gray10, (props) => !props.$isDisabled && css(["box-shadow:var(--thumb-shadow,", ",", "),var(--thumb-border,0 0 0 1px ", ");"], token.elevationStatic, token.elevation1, token.gray75a), token.radiusCircle, (props) => props.$isDisabled ? token.gray400 : token.gray25);
const InputContainer = styled.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-1b6hxsw-6"
})(["width:", ";input{text-align:center;}"], getInputWidth);
function getInputWidth(props) {
  const CHARACTER_WIDTH = 8;
  const MIN_INPUT_WIDTH = 40;
  const maxCharacters = Math.max(props.$min.toString().length, props.$max.toString().length);
  const width = MIN_INPUT_WIDTH + CHARACTER_WIDTH * maxCharacters;
  return `${width}px`;
}
export {
  Container,
  IconStyled,
  InputContainer,
  SliderContainer,
  SliderInput,
  ThumbCircle,
  ThumbContainer
};
//# sourceMappingURL=styles.js.map
